<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
					<section class="content">
						<div class="col-md-12">
							<div class="form-group">
								<label>Description</label>
								<input type="text" class="form-control" placeholder="Enter the description" v-model="form.description">
								<span class="badge badge-danger" v-if="errors.description">{{errors.description}}</span>
							</div>
							<div class="form-group">
								<label>Request Amount</label>
								<input type="number" class="form-control" placeholder="Enter the amount to request" v-model="form.requested_amount" min="1">
								<span class="badge badge-danger" v-if="errors.requested_amount">{{errors.requested_amount}}></span>
							</div>
							<div class="form-group">
								<label>Expense Type</label>
								<v-select placeholder="Choose the expense type" v-model="form.expense_type" :options="expense_types" :reduce="expense_types => expense_types.type" label="type"></v-select>
								<span class="badge badge-danger" v-if="errors.expense_type">{{errors.expense_type}}></span>
							</div>
							<div class="form-group">
								<button class="btn btn-primary" @click="makeRequest">Submit</button>
							</div>
						</div>
					</section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getExpenseTypes();
        },
        
        data(){
        	return {
        		form: new Form({
        			description: '',
        			requested_amount: '',
        			expense_type: ''
        		}),
        		expense_types: [],
        		errors: []
        	}
        },
        
        methods: {
        	getExpenseTypes(){
        		axios.post("/api/getAllExpenseTypes")
        		.then(response => {
        			this.expense_types = response.data;
        		});
        	},
        	
        	makeRequest(){
		      	this.form.post("/api/makeExpenseRequest")
		      	.then(() => {
		      		toast.fire({
		      			icon: 'success',
		      			title: 'Request Created. Await Approval'
		      		});
		      	})
		      	.catch((errors) => {
		      		this.errors = errors.response.data.errors;
		      	})
		      }
        }
    }
</script>
